import { useSelector } from 'react-redux';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';
import has from 'lodash/has';

export function useUserQuarantine() {
  const {
    users: { quarantine },
    entities: { quarantineConfig, credentials, vendors },
    paging: { metaInfoById, sourceConfigById },
  } = useSelector((state: any) => state);
  let quarantineObj;
  let credential = {};
  let connectionInfo;
  let sourceConfigFields;
  let connectionOrVendorType = null;
  if (quarantineConfig && quarantine.id && metaInfoById) {
    quarantineObj = quarantineConfig[quarantine.id];
    credential = credentials[quarantineObj.data_credentials];
    connectionOrVendorType = getConnectionOrVendorType(
      credential,
      vendors,
      'credentials_type',
      'vendor_id',
    );

    connectionInfo = has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType]
      : null;
    sourceConfigFields = sourceConfigById
      ? has(sourceConfigById, connectionOrVendorType)
        ? sourceConfigById[connectionOrVendorType]
        : sourceConfigById[0]
      : null;
  }
  return {
    quarantine: quarantineObj,
    sourceConfigFields,
    credential,
    sourceName: connectionInfo?.name || connectionOrVendorType,
    sourceIcon: connectionInfo?.iconSm,
  };
}
